export default function getYouTubeVideoIdFromUrl(
    url: string
): string | undefined {
    const splittedUrl = url.split('/');

    return splittedUrl[splittedUrl.length - 1];
}
